var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcDiscord = function SvgIcDiscord(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ic_discord_svg__a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 18.046,
    cy: 18.007,
    fill: "#5865F1",
    r: 18
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.63 11.412A17.962 17.962 0 0 0 21.096 10c-.2.363-.418.827-.577 1.21a16.207 16.207 0 0 0-5.034 0c-.179-.424-.377-.827-.596-1.21a16.998 16.998 0 0 0-4.536 1.432c-2.865 4.335-3.64 8.55-3.263 12.725A17.82 17.82 0 0 0 12.66 27c.458-.625.856-1.27 1.194-1.956a10.697 10.697 0 0 1-1.87-.908c.16-.12.298-.242.458-.363a12.847 12.847 0 0 0 11.14 0c.16.121.299.242.458.363-.597.363-1.234.666-1.89.908.338.685.736 1.33 1.194 1.956 2.009-.625 3.899-1.573 5.57-2.843.438-4.84-.796-9.035-3.282-12.745Zm-11.3 10.163c-1.094 0-1.969-1.008-1.969-2.238s.875-2.259 1.97-2.259c1.114 0 1.989 1.009 1.989 2.259-.02 1.23-.875 2.238-1.99 2.238Zm7.322 0c-1.095 0-1.97-1.008-1.97-2.238s.876-2.259 1.97-2.259c1.114 0 1.99 1.009 1.97 2.259-.02 1.25-.876 2.238-1.97 2.238Z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "ic_discord_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h35.999v36H0z"
  })))));
};
export default SvgIcDiscord;